import React from "react";
import PricingCard from "../components/PricingCard";

const LifeStylePortfolio = () => {
  return (
    <>
      <div className="min-h-screen bg-white">
        {/* Hero Section */}
        <section className="text-center py-20 px-5 bg-gradient-to-br from-slate-50 via-white to-teal-50/30 relative overflow-hidden">
          {/* Animated gradient mesh - matching HeroSection */}
          <div className="absolute inset-0 opacity-40">
            <div
              style={{
                backgroundImage: `
                  radial-gradient(circle at 20% 80%, rgba(20, 184, 166, 0.8) 0%, transparent 60%),
                  radial-gradient(circle at 80% 20%, rgba(6, 182, 212, 0.7) 0%, transparent 60%),
                  radial-gradient(circle at 40% 40%, rgba(16, 185, 129, 0.6) 0%, transparent 60%)
                `,
              }}
              className="absolute inset-0"
            ></div>
          </div>

          <div className="max-w-6xl mx-auto relative z-10">
            <h1 className="text-3xl md:text-5xl font-bold mb-5 text-gray-900">
              {shootType}
            </h1>
            <h3 className="text-lg md:text-xl text-teal-600 font-light">{description}</h3>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-20 px-5 bg-white">
          <div className="max-w-6xl mx-auto">
            <div className="max-w-3xl mx-auto mb-16 text-center">
              <p className="text-gray-600 leading-relaxed text-base md:text-lg">
                {introText}
              </p>
            </div>

            <div className="flex flex-col gap-16 md:gap-32 max-w-5xl mx-auto">
              {steps.map((step, index) => (
                <div
                  key={index}
                  className={`flex flex-col md:items-center gap-8 md:gap-12 py-8 md:py-12 ${
                    step.imagePosition === "right"
                      ? "md:flex-row"
                      : "md:flex-row-reverse"
                  }`}
                >
                  <div className="flex-shrink-0 w-full md:w-96 h-96 md:h-[500px] relative mb-8 md:mb-0">
                    <div
                      className={`absolute top-0 ${
                        step.imagePosition === "right" ? "left-0" : "right-0"
                      } w-32 md:w-56 h-full bg-teal-600 rounded-lg z-0`}
                    ></div>
                    <div
                      className={`absolute top-12 md:top-16 ${
                        step.imagePosition === "right" ? "left-8 md:left-16" : "right-8 md:right-16"
                      } w-64 md:w-80 h-96 md:h-[500px] rounded-lg overflow-hidden shadow-2xl z-10 bg-white`}
                    >
                      <img
                        src={step.image}
                        alt={step.title}
                        className="w-full h-full object-cover "
                      />
                    </div>
                  </div>

                  <div className="flex-1">
                    <div className="text-4xl md:text-6xl font-bold text-teal-600 mb-3 md:mb-4">
                      {step.number}
                    </div>
                    <h3 className="text-2xl md:text-3xl font-semibold mb-3 md:mb-4 text-gray-800">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <div className="bg-gradient-to-r from-teal-500 to-teal-600">
          <h1 className="text-center text-2xl md:text-3xl font-bold py-8 text-white px-4">
            Choose your Ideal Plan
          </h1>
          <PricingCard plans={pricingPlans} category="lifestyle" />
        </div>
      </div>
    </>
  );
};

const pricingPlans = [
  {
    title: "LifeStyle Bronze",
    price: "€225",
    features: ["1 Hour Session", "10 Edited Photos", "Online Gallery"],
  },
  {
    title: "LifeStyle Silver",
    price: "€250",
    features: ["2 Hour Session", "20 Edited Photos", "Online Gallery"],
  },
  {
    title: "LifeStyle Gold",
    price: "€275",
    features: [
      "3 Hour Session",
      "30 Edited Photos",
      "Online Gallery"
    ],
  },
];

const shootType = "LifeStyle & Portrait Photography";
const description = "Portraits that tell your story";
const introText =
  `Lifestyle shoots include family portraits, couple shoots and studio portraits. These are available at an outside location or studio or even at your home. During a lifestyle shoot, I capture the 'real' moments for you. I will guide you to create spontaneous moments which always keep the process fun and memorable. I look for elements in nature that are special based on the season to make the photos even beautiful and colorful when we plan an outside location.`;

const steps = [
  {
    number: "01",
    title: "Outdoor portraits",
    description:
      `We begin by exploring the unique ideas and moments you wish to capture. Together, we will select a breathtaking outdoor location that aligns with your vision, carefully considering the season to ensure the setting enhances the mood of your photos. Whether it's the vibrant colors of spring or the golden hues of autumn, we'll find the perfect backdrop. I'll also assist with wardrobe coordination and thoughtful props to bring your concept to life seamlessly.`,
    image:
      "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243732/portrait_girl_tulip_field_bfc51v.jpg",
    imagePosition: "right",
  },
  {
    number: "02",
    title: "Studio portraits",
    description:
      `Experience the convenience of a professional studio right in the comfort of your own space. I bring a complete home studio setup, including lighting and props, directly to your location. We'll select from a variety of backdrops tailored to match your specific vision, ensuring a personalized look and feel. These sessions are perfect for crafting powerful personal branding images that authentically represent you and your story.`,
    image:
      "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243727/male_portrait_black_n_white_3_pkml6k.jpg",
    imagePosition: "left",
  },
  {
    number: "03",
    title: "Family portraits",
    description:
      `My approach is natural and relaxed—you won't feel like you're posing because we'll be creating genuine moments where you can truly be yourself. I focus on capturing authentic emotions and connections, whether it's laughter, tenderness, or quiet moments of reflection. Throughout the session, I'll provide gentle direction while encouraging spontaneity, ensuring you feel comfortable and confident. We'll take breaks when needed, and I'll show you previews along the way so you can see the magic we're creating together. The goal is to make this experience enjoyable and stress-free, resulting in photos that genuinely reflect who you are as a family.`,
    image:
      "https://res.cloudinary.com/shaszstudios-photography/image/upload/v1763243643/family_spring_2_awbeiy.jpg",
    imagePosition: "right",
  },
];

export default LifeStylePortfolio;
